export default __webpack_public_path__ + "static/media/blob.right-md2.3dfedcce.png";